import { InsCommentListUrlSortField } from "@saleor/inscomment/urls";
import { InstagramCommentSortFidls } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: InsCommentListUrlSortField
): InstagramCommentSortFidls {
  switch (sort) {
    case InsCommentListUrlSortField.name:
      return InstagramCommentSortFidls.NAME;
    case InsCommentListUrlSortField.created:
      return InstagramCommentSortFidls.CREATED;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
